import { Sites } from '@ps/platform-message-framework/common/Sites';
import type { Error } from '@ps/web-shared-validators';
import {
  GERMANY_CITY_ALLOWED_CHARACTERS,
  GERMANY_CITY_VALID_CHARACTERS,
  NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
  minLength as minLengthFactory,
  mustContainOnlyLatinCharacters,
  mustNotContainNumber,
  mustNotContainSymbols,
  noConsecutiveSpaces,
  noWhiteStartOrEnd,
  required,
  validateAllowedCharacters
} from '@ps/web-shared-validators';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import {
  TXTWCL_Please_enter_your_cityX,
  TXTWCL_Please_try_againX_This_must_be_ELL,
  TXTWCL_The_city_you_have_entered_is_i_ELL_1
} from './city.messages.json';

export const CITY_MIN_LENGTH = 2;
export const CITY_MAX_LENGTH = 60;

export const useCityFieldValidators = (requiredMessage?: Error['message'], minLength?: number) => {
  const siteId = useSelector(select.cms.getSiteId);
  let validators;

  switch (siteId) {
    case Sites.DE:
      validators = [
        validateAllowedCharacters(GERMANY_CITY_ALLOWED_CHARACTERS, GERMANY_CITY_VALID_CHARACTERS),
        noConsecutiveSpaces
      ];
      break;
    case Sites.GR:
      validators = [
        mustContainOnlyLatinCharacters(),
        mustNotContainSymbols(
          NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
          TXTWCL_The_city_you_have_entered_is_i_ELL_1
        )
      ];
      break;
    default:
      validators = [
        mustNotContainSymbols(
          NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
          TXTWCL_The_city_you_have_entered_is_i_ELL_1
        )
      ];
  }

  return [
    noWhiteStartOrEnd,
    required(requiredMessage || TXTWCL_Please_enter_your_cityX),
    minLengthFactory(minLength || CITY_MIN_LENGTH, {
      ...TXTWCL_Please_try_againX_This_must_be_ELL,
      values: { 0: minLength || CITY_MIN_LENGTH }
    }),
    ...validators,
    mustNotContainNumber(TXTWCL_The_city_you_have_entered_is_i_ELL_1)
  ];
};
